import BaseModel from "./base/baseModel";
import ClienteEmailNotaFiscalModel from "./clienteEmailNotaFiscalModel";
import EnderecoEntregaModel from "./clienteEnderecoEntregaModel";
import ClienteTelefoneModel from "./clienteTelefoneModel";
import BeneficioFiscal from "./enum/cliente/beneficioFiscal";
import IndicativoPresencialConsumidor from "./enum/cliente/indicativoPresencialConsumidor";
import TipoMercado from "./enum/cliente/tipoMercado";
import GenerosPessoa from "./enum/generosPessoa";
import IndicadorOperacao from "./enum/indicadorOperacao";
import OrgaoEmissaoCpfSNGPC from "./enum/orgaoEmissaoCpfSNGPC";
import TipoCliente from "./enum/tipoCliente";
import TiposPessoa from "./enum/tiposPessoa";
import Ufs from "./enum/ufs";
import PacienteModel from "./paciente/pacienteModel";
import ClienteProdutoUsoEspecialModel from "./produto/clienteProdutoUsoEspecialModel";

export default class ClienteModel extends BaseModel {
    constructor() {
        super();

        this.enderecosEntrega = new Array<EnderecoEntregaModel>();
    }

    id?: number = null;
    tipoPessoa: TiposPessoa = TiposPessoa.Fisica;
    tipoPessoaDescricao: string = null;
    nome: string = null;
    nomeFantasia: string = null;
    observacao: string = null;
    cpf: string = null;
    rg: string = null;
    orgaoExpedidor: string = null;
    ufExpedidor?: Ufs = null;
    ufExpedidorDescricao: string = null;
    nomeRotulo: string = null;
    dataNascimento?: Date = null;
    genero?: GenerosPessoa = null;
    generoDescricao: string = null;
    razaoSocial: string = null;
    cnpj: string = null;
    inscricaoEstadual: string = null;
    inscricaoMunicipal: string = null;
    cep: string = null;
    estadoDescricao: string = null;
    estadoId?: Ufs = null;
    cidadeId?: number = null;
    cidade: string = null;
    endereco: string = null;
    bairro: string = null;
    numero: string = null;
    complemento: string = null;
    email: string = null;
    emailsNotaFiscal?: Array<ClienteEmailNotaFiscalModel> = [];
    telefones?: Array<ClienteTelefoneModel> = [];
    enderecosEntrega: Array<EnderecoEntregaModel> = [];
    pacientes: Array<PacienteModel> = [];
    pacienteId?: number = null;
    exterior = false;
    idEstrangeiro: string = null;
    pais?: string = "Brasil";
    codigoPais?: number = 1058;
    contribuinteEstadual = false;
    ativo = true;
    dataCriacao: Date = null;
    beneficioId? = null;
    pacienteCliente = false;
    produtosUsoEspecial?: Array<ClienteProdutoUsoEspecialModel> = [];
    orgaoEmissaoCpfSNGPC?: OrgaoEmissaoCpfSNGPC = null;
    ufEmissaoCpf?: Ufs = null;
    tipoCliente: TipoCliente = TipoCliente.Normal;
    indicadorOperacao: IndicadorOperacao = null;
    issRetido = false;
    naturezaOperacaoDentroEstadoId? = null;
    naturezaOperacaoForaEstadoId? = null;
    telefonePadrao: string = null;
    clienteTributaICMS = false;
    clienteTributaIPI = false;
    clienteTributaPIS = false;
    clienteTributaCOFINS = false;
    notaFiscaisRetencaoCOFINS = false;
    notaFiscaisRetencaoPIS = false;
    notaFiscaisRetencaoCSLL = false;
    notaFiscaisOutrasRetencoes = false;
    clienteControlaRetencoes = false;
    notaFiscaisRetencaoIRRF = false;
    numeroClienteSuframa: string = null;
    codigoIBGECidade: number = null;
    beneficioFiscal: BeneficioFiscal = null;
    indicativoPresencialConsumidor: IndicativoPresencialConsumidor = null;
    freteCliente: string = null;
    contaContabilReduzida1?: number = null;
    contaContabilReduzida2?: number = null;
    tipoAcerto?: number = null;
    clienteCooperado = false;
    codigoRegimeTributario?: number = null;
    naturezaRetencaoPisCofins: string = null;
    tipoDireitoPropriedade?: number = null;
    valorCalculoRetencao: string = null;
    codCondicaoPagamento: string = null;
    codRepresenteLegal?: number = null;
    cbsibsCliente?: number = null;
    tipoEnteGov?: number = null;
    codRotaLocalidade: string = null;
    seqRotaLocalidade: number = null;
    codSubRota: string = null;
    tipoMercado?: TipoMercado = null;
    codRepresentantePadrao?: number = null;
    clienteComEntregaParaTerceiros = false;

    getTelefonePadrao() {
        return this.telefones != null && this.telefones.length > 0
            ? this.telefones.sort((a, b) => (a.padrao ? 1 : -1))[0].telefone
            : "";
    }
}
